module.exports = __webpack_public_path__ + "static/media/ao.a18ccf7d.svg";